import { attachRedirectionOnUnauthorized, attachTokenCallback, setApiUrl } from '@gozoki/api'

// ********************************************************* //
//                     UTILITY FUNCTIONS                     //
// ********************************************************* //

/** Clé du jeton de session dans `localStorage`, partagée par tous les onglets. */
export const TOKEN_STORAGE_KEY = 'bearerToken'

// Token getter
export const getToken = async () => localStorage.getItem(TOKEN_STORAGE_KEY)

// Token setter
export const setToken = async (token: string | null) =>
  localStorage.setItem(TOKEN_STORAGE_KEY, token ?? '')

/**
 * Session refusée par l'API (401 : jeton expiré, révoqué ou supprimé) : jeton effacé, puis
 * chargement complet de la page de connexion. Commun au client axios hérité et aux clients Tuyau.
 */
export const leaveRefusedSession = () => {
  void setToken(null)
  window.location.replace('/login')
}

// ********************************************************* //
//                  INITIALIZE GOZOKI API                    //
// ********************************************************* //
setApiUrl(import.meta.env.VITE_BACKEND_API_ENDPOINT)
attachTokenCallback(getToken)
attachRedirectionOnUnauthorized(leaveRefusedSession)
